<template>
  <v-bottom-nav v-if="$store.state.auth.user.role == 3" v-model="$store.state.auth.loggedIn" color="white" app>
    <!-- <v-btn v-for="(item, index) in items" :key="index" :value="item.title" :to="item.to" color="primary" flat >
      <span>{{ item.title }}</span>
      <v-icon>{{ item.icon }}</v-icon>
    </v-btn> -->
    <v-container v-for="(item, index) in items" :key="index" :value="item.title" pa-0>
      <v-btn color="secondary" flat v-if="item.title!='Logout'" :to="item.to"  >
        <span>{{ item.title }}</span>
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
      <v-btn v-else color="secondary" flat @click="logout()" >
        <span>{{ item.title }}</span>
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
    </v-container>
    
  </v-bottom-nav>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";

export default {
  name: "BottomNavigation",
  components: {},
  data() {
    return {
      items: [
        {title: "Calendar", icon: "schedule", to: { name: "calendar" }},
        {title: "Password", icon: "vpn_key", to: { name: "changePassword" }},
        {title: "Logout", icon: "exit_to_app"},
      ]
    };
  },
  methods: {
    async logout() {
      try {
        // eslint-disable-next-line
        const response = await AuthenticationService.logout({
          userId: this.$store.state.auth.user.email
        });
        // console.log(response.data)
        this.$store.dispatch("logout");
        this.$session.destroy();
        this.$router.push({ name: "signIn" });
        this.$store.dispatch("setSnackbar", { show: true, text: "Logged out", color: "info", x: "right", timeout: 3000 });
      } catch (err) {
        console.log(err.response.data.error);
        this.$store.dispatch("setSnackbar", { show: true, text: "Error Occured", color: "error", x: "right", timeout: 3000 });
      }
    }
  }
};
</script>

<style scoped>
.v-bottom-nav {
  width: 100vw;
}

.v-btn {
  max-width: 33.3vw;
}
</style>
